import { createReceiptDetails } from "./paymentReceiptDetails";

export const buildPaymentDetails = (listState) => ({
  billing_person_id:
    listState.accountHolder.billing_person_id ||
    listState.accountHolder.account_billing_id,
  account_holder_id: listState.accountHolder.id,
  name: listState.accountHolder.person_name,
  email: listState.accountHolder.contact_email,
  subtotal: listState.cartSubtotal,
  amount: listState.cartTotal,
  fee: listState.cartFee,
  tax1: listState.cartTax,
  receipt_details: createReceiptDetails(listState.cartProducts),
});

export const buildInvoiceUpdateDetails = (listState, invoice, invoiceDetails = {}) => {
  if (!listState.cartProducts?.length) {
    throw new Error(
      "This invoice has no items. Add an item, or cancel editing and use Delete Invoice on the Admin page.",
    );
  }
  return {
  ...buildPaymentDetails(listState),
  invoice_id: invoice.id,
  ...(invoice.updated_at != null ? { updated_at: invoice.updated_at } : {}),
  date: invoiceDetails.purchase_date ?? invoice.invoice_date ?? invoice.received ?? invoice.purchase_date,
  reference: invoiceDetails.reference ?? invoice.reference ?? "",
  payment_notes: invoiceDetails.notes ?? invoice.notes ?? "",
  notes: invoiceDetails.notes ?? invoice.notes ?? "",
  receipt_details: listState.cartProducts.map((item) => ({
    ...(item.item_id != null ? { item_id: item.item_id } : {}),
    product_id: item.product_id,
    student_id: item.student_id,
    product_price: Number(item.product_price).toFixed(2),
    amount: Number(item.product_price).toFixed(2),
    start_count: item.start_count,
    purchase_date: item.purchase_date,
    package_start_date: item.package_start_date,
    package_expiry_date: item.package_expiry_date,
    item_notes: item.item_notes ?? "",
  })),
  };
};